import { useState, useEffect, ButtonHTMLAttributes } from 'react'
import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { SubscriptionInventory, SubscriptionSchedule } from '~/api-client/data-contracts'

type Props = {
  schedules: SubscriptionSchedule[]
  selectedInventories: SubscriptionInventory[]
  onChange: (inventoryIds: string[]) => void
}

function formatDeliverWeekday(schedule: SubscriptionSchedule) {
  return format(new Date(1000 * schedule.attributes.deliver_at[0]), 'E', { locale: ja })
}

export const ScheduleSelector: React.FC<Props> = ({ schedules, selectedInventories, onChange }) => {
  const options = Object.groupBy(schedules, (schedule) => formatDeliverWeekday(schedule))
  const weekdays = Object.keys(options).sort((w) => (w === '水' || w === '木' ? -1 : 1))

  const [weekday, setWeekday] = useState<string>(() => {
    if (selectedInventories.length === 0) {
      return weekdays[0]
    } else {
      return formatDeliverWeekday(schedules.find((s) => s.relationships.inventory.data.id === selectedInventories[0].id))
    }
  })

  useEffect(() => {
    handleFreqChange(selectedInventories.length || 1)
  }, [weekday])

  const handleFreqChange = (time: number) => {
    let inventories = []

    if (time === 1) inventories = [options[weekday][0]]
    if (time === 2) inventories = [options[weekday][0], options[weekday][2]]

    onChange(inventories.map((s) => s.relationships.inventory.data.id))
  }

  return (
    <>
      {weekdays.length > 1 && (
        <div>
          <p className="text-[12px] text-dark-gray mb-3">
            受け取りたい曜日を選んでください <span className="text-accent">*</span>
          </p>
          <div className="flex gap-2 flex-wrap">
            {weekdays.map((day) => (
              <RadioButton key={day} active={weekday === day} onClick={() => setWeekday(day)}>
                {day}
              </RadioButton>
            ))}
          </div>
        </div>
      )}
      <div>
        <p className="text-[12px] text-dark-gray mb-3">
          受け取りたい頻度を選んでください <span className="text-accent">*</span>
        </p>
        <div className="flex gap-2">
          {[1, 2].map((count) => (
            <RadioButton key={count} active={selectedInventories.length === count} onClick={() => handleFreqChange(count)}>
              月{count}回
            </RadioButton>
          ))}
        </div>
      </div>
    </>
  )
}

type ButtonProps = {
  active: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>

const RadioButton: React.FC<ButtonProps> = ({ active, children, onClick }) => {
  const baseClass = 'px-4 py-2 rounded-full text-[13px] font-medium transition-colors cursor-pointer'
  const activeClass = 'border border-black bg-black text-white'
  const inactiveClass = 'border border-gray text-main hover:border-black'

  return (
    <button type="button" onClick={onClick} className={`${baseClass} ${active ? activeClass : inactiveClass}`}>
      {children}
    </button>
  )
}
